module.exports = __webpack_public_path__ + "static/img/esales-3.9922140.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zsy_esales/esales-3.png
// module id = 241
// module chunks = 6